// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"my-account_routeHeader_1NKfo","addButton":"my-account_addButton_Y0OOK","client-card":"my-account_client-card_2oe0r","error":"my-account_error_3v5by"};